const Name = (cell) => {
  return cell.getValue() ? cell.getValue() : "";
};

const CreatedBy = (cell) => {
  return cell.getValue() ? cell.getValue() : "";
};

const APIKeys = (cell) => {
  // Controlled value (not defaultValue): the table reuses DOM inputs across
  // re-renders/sorts, so an uncontrolled input keeps showing another row's key.
  return (
    <input type="text" className="form-control apikey-value" readOnly value={cell.getValue() || ""} onFocus={(e) => e.target.select()} />
  );
};

const Status = (cell) => {
  console.log(cell.getValue())
  switch (cell.getValue()) {
    case true:
      return <span className="badge bg-success-subtle text-success"> Enabled </span>;
    case false:
      return <span className="badge bg-danger-subtle text-danger"> Disabled </span>;
    default:
      return <span className="badge bg-success-subtle text-success"> {cell.getValue()} </span>;
  }
};

const CreatedDate = (cell) => {
  return cell.getValue() ? cell.getValue() : "";
};

const ExpiryDate = (cell) => {
  return cell.getValue() ? cell.getValue() : "";
};

export { Name, CreatedBy, APIKeys, Status, CreatedDate, ExpiryDate };
